import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext.js";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "./schemas/authenticationSchema.js";

import Button from "../../components/Button.js";
import Input from "../../components/Input.js";

import { signIn } from "../../api/authRequest.js";

import LearnMoreSection from "../../components/LearnMore.js";
import { useTranslation } from "../../i18n/TranslationProvider";

const SignIn = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(loginSchema),
    });

    const onSubmit = async (data) => {
        setError("");
        try {
            const res = await signIn(data);
            login(res.data.userId);
            navigate("/athletes");
        } catch (err) {
            console.error("Error logging in:", err);
            if (err.response?.status === 401) {
                setError(t("auth.loginErrorInvalid"));
            } else {
                setError(t("auth.loginErrorGeneric"));
            }
        }
    };

    return (
        <>
            <div className="custom-container w-4/5 md:w-2/3 lg:w-1/2 mx-auto">
                <div className="text-base md:text-2xl text-center mx-auto mb-6">
                    <h4 className="mb-2">{t("auth.login")}</h4>
                    <p>{t("auth.loginSubheading")}</p>
                </div>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input
                        label={t("auth.email")}
                        name="email"
                        register={register}
                        errors={errors}
                        placeholder={t("auth.emailPlaceholder")}
                    />
                    <Input
                        label={t("auth.password")}
                        name="password"
                        type="password"
                        register={register}
                        errors={errors}
                        placeholder={t("auth.passwordPlaceholder")}
                    />
                    <p
                        className=" text-teal-600 font-semibold cursor-pointer"
                        onClick={() => navigate("/forgot-password")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/forgot-password");
                            }
                        }}
                    >
                        {t("auth.forgotPasswordLink")}
                    </p>
                    {error && <p className=" text-red-600">{error}</p>}
                    <Button type="submit" isLoading={isSubmitting}>
                        {t("auth.login")}
                    </Button>
                </form>
                <hr className="mt-6 border border-gray-200 w-full p-0 mx-auto" />
                <div className="mt-4 px-2 flex justify-between items-center">
                    <p>{t("auth.noAccount")}</p>
                    <h6
                        className="text-teal-600 cursor-pointer"
                        onClick={() => navigate("/register")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/register");
                            }
                        }}
                    >
                        {t("auth.register")}
                    </h6>
                </div>
                <div className="mt-2 px-2 flex justify-between items-center">
                    <p>{t("auth.needHelp")}</p>
                    <h6
                        className="text-teal-600 cursor-pointer"
                        onClick={() => navigate("/help")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/help");
                            }
                        }}
                    >
                        {t("auth.contactUs")}
                    </h6>
                </div>
            </div>
        </>
    );
};

export default SignIn;